import { Checkbox, FormControlLabel, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TERMS_OF_USE } from '../../routes/routes'

interface Props {
  name: string
}

const AgreeTermsCheckbox = (props: Props) => {
  const { name } = props

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Stack>
      <FormControlLabel
        control={
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <Checkbox
                name={name}
                checked={field.value}
                color="primary"
                required={true}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />
        }
        label={
          <Typography variant="body2">
            By clicking here you indicate you have read and agree to our{' '}
            <Link color="inherit" href={TERMS_OF_USE} target="_blank">
              Terms and Conditions
            </Link>
            .
          </Typography>
        }
      />
      {errors[name] ? (
        <Typography variant="body2" sx={{ fontSize: '0.75rem' }} color="error">
          {(errors[name] as { message?: string })?.message || ''}
        </Typography>
      ) : (
        ''
      )}

      <Typography variant="body2">
        You will receive friendly reminders from the ProActive Memory Services team after sign-up.
        These reminders can be managed anytime from your profile settings.
      </Typography>
    </Stack>
  )
}

export default AgreeTermsCheckbox
